const url = '/creditCards';
const Provider = 'CreditCards';
const dbModel = 'CreditCards';

export { url, Provider, dbModel };
